import React, { useState, useEffect } from "react";
import styles from "./MyApplications.module.css";

import { ApprovedSvg, RejectSvg, ForConsiderationSvg } from "../../img/Image";
import Carousel from "../../components/сarousel/Carousel";
import { SkeletonCard } from "../../components/skeleton/card/SkeletonCard";

import { formatDateRange, useScreenSize } from "../../components/auxiliaryFunctions";
import { StubMyEvents } from "../../components/stub/Stub";

import { useApi } from '../../utils/useApi';
import { createAuthApi } from './api';

const MyApplications = ({ isToken }) => {
    const { isMobile } = useScreenSize();
    const { customFetch } = useApi();
    const authApi = createAuthApi(customFetch);

    const isProfileFilled = false
    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const getUsersApplications = async () => {
        setIsLoading(true);
        try {
            const result = await authApi.postUserApplications();
            if (result) {
                setEvents(result.applications);
            }
        } catch (error) {
            console.error('Events failed:', error);
        } finally {
            await delay(300);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (isToken) {
            getUsersApplications();
        } else {
            setIsLoading(false);
        }
    }, [isToken])
    return (
        <main className={styles.mainContent}>
            {!isMobile && (
                <div className={styles.headerBox}>
                    <h1 className={styles.title}>Мои заявки</h1>
                </div>
            )}
            <div className={styles.eventsContainer}>
                {isLoading ? (
                    <SkeletonCard count={isMobile ? 1 : 3} />
                ) : events.length == 0 ? (
                    <StubMyEvents />
                ) : (
                    <Carousel events={events} isProfileFilled={isProfileFilled} Card={EventCard} isMobile={isMobile} />
                )}
            </div>
        </main>
    );
}

const EventCard = ({ event, isProfileFilled, sendAnApplication }) => {

    const getImage = (status) => {
        switch (status) {
            case "approved":
                return <ApprovedSvg className={styles.statusImg} />;
            case "sent":
                return <ForConsiderationSvg className={styles.statusImg} />;
            case "onReview":
                return <ForConsiderationSvg className={styles.statusImg} />;
            case "rejected":
                return <RejectSvg className={styles.statusImg} />;
            default:
                return null;
        }
    }

    const getBodyStatus = (status) => {
        switch (status) {
            case "approved":
                return (
                    <div className={styles.contentApproved}>
                        <div className={styles.contentName} style={{ color: "#FFFFFF" }}>
                            ПОЗДРАВЛЯЕМ! ЗАЯВКА ОДОБРЕНА
                        </div>
                    </div>
                );
            case "sent":
                return (
                    <div className={styles.contentInfo}>
                        <div className={styles.contentName}>
                            ЗАЯВКА НА РАССМОТРЕНИИ
                        </div>
                    </div>
                );
            case "onReview":
                return (
                    <div className={styles.contentInfo}>
                        <div className={styles.contentName}>
                            ЗАЯВКА НА РАССМОТРЕНИИ
                        </div>
                    </div>
                );
            case "rejected":
                return (
                    <div className={styles.contentInfo}>
                        <div className={styles.contentName}>
                            ЗАЯВКА ОТКЛОНЕНА
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    const getText = (status) => {
        switch (status) {
            case "sent":
                return (<p className={styles.eventDescription}>Ждите сообщение от координатора ВФТМ</p>);
            case "onReview":
                return (<p className={styles.eventDescription}>Ждите сообщение от координатора ВФТМ</p>);
            case "approved":
                return (<p className={styles.eventDescription}>Ждите сообщение от координатора ВФТМ</p>);
            case "rejected":
                return (<p className={styles.eventDescription}></p>);
            default:
                return null;
        }
    }

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <div className={styles.dateLocation}>
                    <div className={styles.date}>{formatDateRange(event.beginDate, event.endDate)}</div>
                    <div className={styles.location}>{event.city}</div>
                </div>
                <div className={styles.status}>
                    {getImage(event.applicationStatus)}
                </div>
            </div>

            <div className={styles.content}>
                <h3 className={styles.eventTitle}>{event.name}</h3>
            </div>

            {getBodyStatus(event.applicationStatus)}

            <div className={styles.actions}>
                {getText(event.applicationStatus)}
            </div>

            <div className={styles.actionsLink}>
                <div></div>
                <div className={styles.infoEvent}>
                    <a
                        href={event.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.eventLink}
                    >
                        О событии
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MyApplications;